<template>
  <div class="animated-svg-illustration" v-html="svgMarkup" />
</template>

<script>
import { uniquifySvgIds } from "@/utils/svg";

export default {
  name: "AnimatedSvgIllustration",
  props: {
    src: {
      type: String,
      required: true,
    },
    uid: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      svgMarkup: "",
    };
  },
  async mounted() {
    await this.loadSvg();
  },
  watch: {
    src() {
      this.loadSvg();
    },
  },
  methods: {
    async loadSvg() {
      try {
        const response = await fetch(this.src);
        const text = await response.text();
        this.svgMarkup = uniquifySvgIds(text, this.uid);
      } catch (error) {
        console.error("SVG load failed:", error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.animated-svg-illustration {
  width: 100%;

  ::v-deep svg {
    display: block;
    width: 100%;
    height: auto;
  }
}
</style>
